import { useState, useEffect, useRef } from "react"
import { PropTypes } from "prop-types"
import _ from "lodash"

/**
 * toggleWrap HOC component.
 * @param {class} ToggledComponent, component that will receive "show" prop.
 * @returns {class} ToggleWrapper, new component wrapping ToggledComponent.
 */
export function toggleWrap(ToggledComponent) {
  function ToggleWrapper(props) {
    const { defaultOpen = false, onChange = _.noop } = props
    const didMount = useRef(false)
    const [show, setShow] = useState(defaultOpen)

    useEffect(() => {
      if (didMount.current) {
        onChange(show)
      } else {
        didMount.current = true
      }
    }, [show, onChange])

    const handleChange = () => {
      setShow(!show)
    }

    return <ToggledComponent show={show} {...props} onChange={handleChange} />
  }

  ToggleWrapper.propTypes = {
    defaultOpen: PropTypes.bool,
    onChange: PropTypes.func
  }

  return ToggleWrapper
}

export default toggleWrap
